const swiper = new Swiper('.swiper-container', {
  // navigation: {
  //   nextEl: ".swiper-button-next",
  //   prevEl: ".swiper-button-prev",
  // },
  pagination: {
    el: ".swiper-pagination", 
    type: "bullets",
    clickable: "clickable",
  },
  loop: true, 
  centeredSlides: true,
  spaceBetween: 10,
  speed: 1500,
  autoplay: {delay: 3000},
  slidesPerView: 1,
  centeredSlides: true,
  centeredSlidesBounds: true,
  breakpoints: {
    1024: {
      slidesPerView: 1.5,
      loop: true, 
      speed: 1500, 
      autoplay: {delay: 3000},
      // navigation: {
      //   nextEl: ".swiper-button-next",
      //   prevEl: ".swiper-button-prev",
      // },
    }
  }
}
);




